/*eslint-disable */
import { MAX_ALLOWED_MEMBERS } from "./groupMembers.constants";

export const getGroupMemberIds = (group = {}) => {
  const { members = [] } = group;
  const memberIds = members.map((member) => member.value);
  return memberIds;
};

const isMemberWithSearchText = (searchText) => (member) => {
  return (
    member["firstName"].includes(searchText) ||
    member["lastName"].includes(searchText)
  );
};

const getFilteredGroupMembers = (groupMembers, searchText) => {
  const filteredGroupMembers = groupMembers.filter(
    isMemberWithSearchText(searchText)
  );
  return filteredGroupMembers;
};

export const getGroupMembers = ({ allUsers, searchText, group }) => {
  const groupMemberIds = getGroupMemberIds(group);
  const groupMembers = allUsers.filter((user) =>
    groupMemberIds.includes(user.id)
  );
  if (searchText) {
    return getFilteredGroupMembers(groupMembers, searchText);
  }
  return groupMembers;
};

/**
 * Usage:
 * const users = useMemo(() => getGroupMembers({ group, searchText, allUsers}), [group, allUsers, searchText])
 */

export const getFilteredMembers = (group = {}, searchText = "") => {
  const { members = [] } = group;

  if (searchText) {
   
    searchText=searchText.toLocaleLowerCase()
    return members.filter((member) => (member?.display).toLowerCase().includes(searchText) || (member?.email).toLowerCase().includes(searchText));
  
  }
  return members;
};

export const isMemberSelected = (selectedMember, selectedMembers = []) =>
  selectedMembers.includes(selectedMember);

export const areAllMembersChecked = (members = [], selectedMembers = []) => {
  if (members.length > 0) {
    return members.every((member) =>
      isMemberSelected(member.value, selectedMembers)
    );
  }
  return false;
};

export const getSelectedMembersWithOutSelectedMemberId = (
  selectedMembers,
  selectedMemberId
) => {
  const filteredSelectedMembers = selectedMembers.filter(
    (selectedMember) => selectedMember !== selectedMemberId
  );
  return filteredSelectedMembers;
};

export const createMember = () => {};

export const getSelectedMembersCount = (selectedMembers = []) => {
  return selectedMembers.length;
};

export const shouldDisableSelectAll = (members = [], selectedMembers = []) => {
  const selectedMembersCount = getSelectedMembersCount(selectedMembers);
  const membersCount = members?.length;
  const allMembersChecked = areAllMembersChecked(members, selectedMembers);
  if (
    selectedMembersCount >= MAX_ALLOWED_MEMBERS ||
    (membersCount > MAX_ALLOWED_MEMBERS - selectedMembersCount &&
      !allMembersChecked)
  ) {
    return true;
  }
  return false;
};

export const shouldDisableMember = (member, selectedMembers = []) => {
  const selectedMembersCount = getSelectedMembersCount(selectedMembers);
  if (
    selectedMembersCount >= MAX_ALLOWED_MEMBERS &&
    !isMemberSelected(member?.value, selectedMembers)
  ) {
    return true;
  }
  return false;
};

export const getFirstName = member => {
  const [firstName, ...restName] = member['display']?.split(" ") || [];
  return firstName
}


export const getLastName = member => {
  const [firstName, ...lastName] = member['display']?.split(" ") || [];
  return `${lastName?.[0]} ${lastName?.[1] ? lastName?.[1]: ''}`
}

const getValue = (obj, sortBy) => {
  if(sortBy == 'firstName') {
    return getFirstName(obj);
  }
  return getLastName(obj);
}

export const sortMembers = ({ members, sortBy, sortOrder }) =>  [...members].sort((a, b) => {

  const isAsc = sortOrder === 'asc';
  return isAsc ? a[sortBy]?.localeCompare(b[sortBy]) : b[sortBy]?.localeCompare(a[sortBy]);
});
